// extracted by mini-css-extract-plugin
export default {"popups-root":"LngR6M","popupsRoot":"LngR6M","popups-wrapper":"NSl5q_","popupsWrapper":"NSl5q_"};